import classnames from 'classnames';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DropdownContext } from '../Dropdown/DropdownContext';

const DropdownToggle = ({ children, className, tag: Tag, ...props }) => {
  const value = useContext(DropdownContext);

  return (
    <Tag
      className={classnames({ active: value.isOpen }, className)}
      data-testid="DropdownToggle"
      onClick={value.toggle}
      {...props}
    >
      {typeof children === 'function' ? children(value) : children}
    </Tag>
  );
};

DropdownToggle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

DropdownToggle.defaultProps = {
  children: null,
  className: null,
  tag: 'div',
};

export default DropdownToggle;
